import React from 'react';

const ProductsListingPage = React.lazy(() => import('pages/products/listing'));
const ProductsDetailsPage = React.lazy(() => import('pages/products/details'));
const ProductEditPage = React.lazy(() => import('pages/products/edit'));
const EditNonWineProductPage = React.lazy(() => import('pages/products/non-wine'));
const SubmitNewNonWineProductPage = React.lazy(() => import('pages/products/non-wine'));

const policies = [{ resource: 'productInventories', action: 'view' }];

export const definitions = [
  {
    path: 'groups',
    policies: policies,
    component: <ProductsListingPage />
  },
  {
    path: 'vintages',
    policies: policies,
    component: <ProductsListingPage />
  },
  {
    path: 'details/:productGroupID',
    policies: policies,
    component: <ProductsDetailsPage />
  },
  {
    path: 'edit/:productID',
    policies: policies,
    component: <ProductEditPage />
  },
  {
    path: 'edit/non-wine/:productID',
    policies: policies,
    component: <EditNonWineProductPage />
  },
  {
    path: 'new/non-wine',
    policies: policies,
    component: <SubmitNewNonWineProductPage />
  }
];
